import { Route, RouteRecord } from 'vue-router'
import USER_TYPES from '@/constants/authorization/user-types'
import { SETUP_WIZARDS } from '@/constants/setup-wizards'
import store from '@/store'
import { PACKAGE_PERMISSIONS } from '@/constants/features'

export function getRequiredUserTypesFromRoute(to: Route) {
  const requiredTypes: Array<Array<string>> = to.matched.reduce((prev: any, current: RouteRecord) => {
    const { userTypes, onlyOwner, onlySuperAdmin } = current?.meta ?? {}

    if (onlySuperAdmin) return [...prev, [USER_TYPES.SUPER_ADMIN]]
    if (onlyOwner) return [...prev, [USER_TYPES.OWNER]]

    return (userTypes ? [...prev, Array.isArray(userTypes) ? userTypes : [userTypes]] : prev)
  }, [])
  return requiredTypes
}

export function isUserHasTypes(userTypes: Array<Array<string>>, isUserHasType: Function) {
  for (let i = 0; i < userTypes.length; i += 1) {
    const types = userTypes[i]
    const isFailed = !types.some((type: string) => isUserHasType(type, false))
    if (isFailed) {
      return false
    }
  }
  return true
}

export function getAdminPermissionsFromRoute(to: Route) {
  const permissions: Array<Array<string>> = to.matched.reduce((prev: any, current: RouteRecord) => {
    const { adminPermissions } = current?.meta ?? {}
    return (adminPermissions ? [...prev, Array.isArray(adminPermissions) ? adminPermissions : [adminPermissions]] : prev)
  }, [])
  return permissions
}

export function isSuperAdminHasPermissions(permissions: Array<Array<string>>, permissionChecker: Function) {
  for (let i = 0; i < permissions.length; i += 1) {
    const types = permissions[i]
    const isFailed = !types.some((permission: string) => permissionChecker(permission))
    if (isFailed) {
      return false
    }
  }
  return true
}

export function getPackagePermissionsFromRoute(to: Route) {
  const permissions: Array<Array<string>> = to.matched.reduce((prev: any, current: RouteRecord) => {
    const { packagePermissions } = current?.meta ?? {}
    return (packagePermissions ? [...prev, Array.isArray(packagePermissions) ? packagePermissions : [packagePermissions]] : prev)
  }, [])
  return permissions
}

export function isSubscriptionHasPermissions(permissions: Array<Array<string>>, permissionChecker: Function) {
  for (let i = 0; i < permissions.length; i += 1) {
    const types = permissions[i]
    const isFailed = !types.some((permission: string) => permissionChecker(permission))
    if (isFailed) {
      return false
    }
  }
  return true
}

export function skipWizardByPackagePermission(wizard: string) {
  switch (wizard) {
    // case SETUP_WIZARDS.QUEUE_RESERVATION: return !(store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.RESERVATION) && store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.QUEUE))
    case SETUP_WIZARDS.DEVICES: case SETUP_WIZARDS.DESIGN_TABLET: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.IPAD)
    case SETUP_WIZARDS.DESIGN_QR: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.QR_CUSTOMIZATION)
    case SETUP_WIZARDS.SURVEY: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.FEEDBACK)
    case SETUP_WIZARDS.COUPONS: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.COUPON)
    case SETUP_WIZARDS.DISCOUNTS: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.DISCOUNT)
    case SETUP_WIZARDS.NEWSLETTER: return !store.getters['subscription/canAccessFeature'](PACKAGE_PERMISSIONS.NEWSLETTER)
    default: return false
  }
}

export function skipWizardStepByPackagePermission(step: string) {
  switch (step) {
    case 'queue': case 'reservation': return !store.getters['subscription/canAccessFeature'](step)
    default: return false
  }
}
